import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

export const getCreditDebitNotesReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };

    if (searchQuery.note_type) params.note_type = searchQuery.note_type;
    if (searchQuery.search) params.search = searchQuery.search;
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.invoice_type_id) params.invoice_type_id = searchQuery.invoice_type_id;
    if (searchQuery.flat_id) params.flat_id = searchQuery.flat_id;
    if (searchQuery.invoice_id) params.invoice_id = searchQuery.invoice_id;
    if (searchQuery.status) params.status = searchQuery.status;
    if (searchQuery.from_date) params.from_date = searchQuery.from_date;
    if (searchQuery.to_date) params.to_date = searchQuery.to_date;
    if (searchQuery.is_active !== undefined) params.is_active = searchQuery.is_active;

    return axiosInstance.get(apiEndpoints.GET_CREDIT_DEBIT_NOTES_API, { params });
}

export const getCreditDebitNoteDetailsReq = (action) => {
    const noteId = action?.data?.id || '';
    const url = apiEndpoints.GET_CREDIT_DEBIT_NOTE_DETAILS_API.replace(':id', noteId);
    return axiosInstance.get(url);
}

export const getCreditDebitNotesByInvoiceReq = (action) => {
    const invoiceId = action?.data?.invoice_id || '';
    const url = apiEndpoints.GET_CREDIT_DEBIT_NOTES_BY_INVOICE_API.replace(':invoice_id', invoiceId);
    return axiosInstance.get(url);
}

export const createCreditDebitNoteReq = (action) => {
    let payload = { ...action?.data } || {};
    delete payload.onSuccess;
    return axiosInstance.post(apiEndpoints.CREATE_CREDIT_DEBIT_NOTE_API, payload);
}

export const updateCreditDebitNoteReq = (action) => {
    const noteId = action?.data?.id || '';
    let payload = { ...action?.data } || {};
    delete payload.id;
    delete payload.onSuccess;
    const url = apiEndpoints.UPDATE_CREDIT_DEBIT_NOTE_API.replace(':id', noteId);
    return axiosInstance.put(url, payload);
}

export const postCreditDebitNoteReq = (action) => {
    const noteId = action?.data?.id || '';
    const url = apiEndpoints.POST_CREDIT_DEBIT_NOTE_API.replace(':id', noteId);
    return axiosInstance.post(url);
}

export const voidCreditDebitNoteReq = (action) => {
    const noteId = action?.data?.id || '';
    const url = apiEndpoints.VOID_CREDIT_DEBIT_NOTE_API.replace(':id', noteId);
    const payload = {};
    if (action?.data?.reason) payload.reason = action.data.reason;
    return axiosInstance.post(url, payload);
}

export const deleteCreditDebitNoteReq = (action) => {
    const noteId = action?.data?.id || '';
    const url = apiEndpoints.DELETE_CREDIT_DEBIT_NOTE_API.replace(':id', noteId);
    return axiosInstance.delete(url);
}

export const downloadCreditDebitNoteTemplateReq = (action) => {
    const params = {};
    if (action?.data?.society_id) params.society_id = action.data.society_id;
    if (action?.data?.invoice_type_id) params.invoice_type_id = action.data.invoice_type_id;
    return axiosInstance.get(apiEndpoints.DOWNLOAD_CREDIT_DEBIT_NOTE_TEMPLATE_API, {
        params,
        responseType: 'blob',
    });
}

export const bulkUploadCreditDebitNotesReq = (action) => {
    const { society_id, invoice_type_id, file } = action?.data || {};
    const formData = new FormData();
    formData.append('file', file);
    formData.append('society_id', society_id);
    formData.append('invoice_type_id', invoice_type_id);
    return axiosInstance.post(apiEndpoints.BULK_UPLOAD_CREDIT_DEBIT_NOTES_API, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}

export const bulkGetCreditDebitNoteDetailsReq = (action) => {
    const { note_ids } = action?.data || {};
    return axiosInstance.post(apiEndpoints.BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_API, { note_ids });
}

export const bulkPostCreditDebitNotesReq = (action) => {
    const { note_ids } = action?.data || {};
    return axiosInstance.post(apiEndpoints.BULK_POST_CREDIT_DEBIT_NOTES_API, { note_ids });
}

export const bulkDeleteCreditDebitNotesReq = (action) => {
    const { note_ids } = action?.data || {};
    return axiosInstance.post(apiEndpoints.BULK_DELETE_CREDIT_DEBIT_NOTES_API, { note_ids });
}
